import * as React from 'react';
import classNames from 'classnames';

import { TFooterType } from '../../types/footerType';

import * as styles from './Footer.css';
import * as gridStyles from '../../utils/grid.css';

interface IFooterProps {
  legalDocuments: React.ReactNode;
  links: React.ReactNode;
  cianGroup: React.ReactNode;
  projects: React.ReactNode;
  bottomStripe: React.ReactNode;
  type: TFooterType;
}

export const Footer: React.FC<IFooterProps> = ({ legalDocuments, links, cianGroup, projects, bottomStripe, type }) => {
  return (
    <div
      className={classNames(
        styles['c-footer'],
        type === 'adaptive' && styles['c-footer-adaptive'],
        type === 'mobile' && styles['c-footer-mobile'],
      )}
    >
      <div className={gridStyles['cg-container-fluid-xs']}>
        <div className={gridStyles['cg-row']}>
          {legalDocuments}
          {links}
          {cianGroup}
          {projects}
        </div>
      </div>
      {bottomStripe}
    </div>
  );
};
